import NewBsBox from './NewBsBox'

export default function WithBsBox({
  bs: initBs,
  as = 'div',
}) {
  const Cmp = (props, { slots, attrs }) => {
    const { bs, as: passAs } = props
    return (
      <NewBsBox
        as={passAs || as}
        bs={{
          ...initBs,
          ...bs,
        }}
        {...attrs}
      >
        {slots.default()}
      </NewBsBox>
    )
  }
  Cmp.props = {
    bs: {
      type: Object,
      default: () => ({}),
    },
    as: {
      type: String,
    },
  }
  return Cmp
}
